/**
 * The height of every control on the Registration tab's scope row — the Season
 * select, the Section switcher and Player Finder's competition picker — so they
 * line up. Taller than the 40px control default because the pickers show two
 * lines (name + dates / division): 20.3px + 17.4px of text plus ~5px padding.
 */
export const SCOPE_CONTROL_HEIGHT = 48
